var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"l-button",class:{ 'l-button--success': _vm.type === 'success', 'l-button--warning': _vm.type === 'warning', 'l-button--danger': _vm.type === 'danger', 'l-button--md': _vm.size === 'md', 'l-button--fill': _vm.size === 'fill' },attrs:{"id":_vm.id,"disabled":_vm.disabled},on:{"click":_vm.onClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }